import React, { FC } from 'react';
import styles from './SecurityGuidelines.module.scss';
import SNS from "../../../assets/images/SNS_Form.png";
import ARG from "../../../assets/images/ARG_Form.png";
import {Helmet} from "react-helmet";


interface SecurityGuidelinesProps {}
const SecurityGuidelines: FC<SecurityGuidelinesProps> = () => (

  <div className={styles.SecurityGuidelines}>

      <Helmet>
          <meta charSet="utf-8"/>
          <title>Security Guidelines</title>
      </Helmet>

      <div className="standard-margin">
      <h1> Security Classification Guide</h1>
          <hr></hr>
   <h2>TIC Collections are Classified into 4 Categories:</h2>

   <ol>
       <li> Public: This classification level contains information that can be made available to the public. Items widely distributed or posted to public websites and databases are public. Items where the distribution poses no potential harm to National Park Service (NPS) resources or to anyone that has submitted information to the National Park Service.</li>
       <br></br>
       <li>Restricted: This classification level designates items available to NPS employees and contractors. Samples of restricted documents include floor plans of administrative offices, residences, or storage for exhibit, operational facilities where large numbers of people gather (such as visitor centers and restaurants).</li>
       <br></br>
       <li>  Sensitive: This classification level is available to NPS employees who have submitted an authorized Sensitive Information (SNS) security agreement, with the required approval from their supervisor. Items, which if released, pose a credible threat to National Park Service (NPS) cultural or natural resources, rare species, or infrastructure.</li>
       <br></br>
       <div className="SNS">
           <a href={require('../../../assets/documents/Form_SNS_ETIC_Agreement_v508 .pdf')} target="_blank">
           <img src={SNS} alt="SNS thumbnail" className={styles.thumbnail} /></a>
       </div>

       <br></br>
       <li>  Archeological: This classification level is available to NPS employees who have submitted an authorized Sensitive Archeological Information (ARG) agreement, with the required approval from their supervisor.</li>
       <br></br>
       <div className="ARG">
           <a href={require('../../../assets/documents/Form_ETIC_Archeology_v508.pdf')} target="_blank">
           <img src={ARG} alt="ARG thumbnail" className={styles.thumbnail} /></a>
       </div>
   </ol>
  </div>
      <br></br>  <br></br>
  </div>
);

export default SecurityGuidelines;
